import { createListenerMiddleware } from "@reduxjs/toolkit";
import { getProductTechnicalDrawing } from "@/lib/product.ts";
import { productsSetCurrentProductReferenceAction } from "@/redux/slices/products-slice.ts";
import { subFamilySetTechnicalDrawingAction } from "@/redux/slices/sub-family-slice.ts";
import type { AppDispatch, RootState } from "@/redux/store.ts";
import type { Nullable } from "@/types";

const technicalDrawingMiddleware = createListenerMiddleware();

/**
 * Updates the technical drawing whenever the current product reference changes
 */
technicalDrawingMiddleware.startListening.withTypes<RootState, AppDispatch>()({
    actionCreator: productsSetCurrentProductReferenceAction,
    effect: (action, api) => {
        const productReference = action.payload;

        let technicalDrawing: Nullable<string>;

        if (!productReference) {
            technicalDrawing = null;
        } else {
            const products = api.getState().products.items;
            const product = products[productReference];

            technicalDrawing = getProductTechnicalDrawing(product);
        }

        api.dispatch(subFamilySetTechnicalDrawingAction(technicalDrawing));
    },
});

export default technicalDrawingMiddleware.middleware;
